import { render } from "./AuctionCard.vue?vue&type=template&id=fb5812c0"
import script from "./AuctionCard.vue?vue&type=script&lang=js"
export * from "./AuctionCard.vue?vue&type=script&lang=js"

import "./AuctionCard.vue?vue&type=style&index=0&id=fb5812c0&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__